import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { PaginationLinks } from './pagination-links.component'
import { CommonModule } from '@angular/common'

@NgModule({
  declarations: [PaginationLinks],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [PaginationLinks]
})
export class PaginationModule {}
